import { TDR } from 'tdr-common';
import Availability = TDR.Availability;

/**
 * Minimal table DTO - only includes fields required for availability queries
 * Re-exported from tdr-common for convenience
 */
export type TableDTO = Availability.TableDTO;

/**
 * Converts full table objects to minimal DTOs
 * Only extracts the fields needed for availability calculations
 */
export const toTableDTO = (tables: TDR.Table[]): TableDTO[] =>
	tables.map(t => ({
		id: t.id,
		minGuests: t.minGuests,
		maxGuests: t.maxGuests
	}));

/**
 * Client input types - accept full tables and convert to DTOs before sending to server
 */
export type ClientCalendarAvailabilityInput = Omit<Availability.getCalendarAvailabilityInput, 'tables'> & {
	tables: TDR.Table[];
};

export type ClientSupportedGroupSizesInput = Omit<Availability.getSupportedGroupSizesInput, 'tables'> & {
	tables: TDR.Table[];
};

export type ClientSearchInput = Omit<Availability.searchInput, 'space'> & {
	space: TDR.Table[];
	queryEnabled?: boolean;
};
